/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

export const invitationsPageEn = {
  failedAccept: 'The invitation could not be accepted! Please try again later.',
  loadingError:
    "We're sorry! Unfortunately, the data could not be retrieved. Please try again later.",
  invalid: {
    title: 'Link invalid :(',
    description:
      "We're sorry! The invitation link is unfortunately no longer valid. The invitation may have expired or been revoked.",
    options: 'Contact the person who invited you to receive a new invitation.'
  },
  success: {
    title: 'Successfully Joined',
    description:
      'You have successfully joined the organization "{{organization}}".',
    options: "You don't need to do anything else.",
    toMarketplace: 'To Marketplace',
    manage: 'Manage Membership',
    toProfile: 'Go to Profile'
  },
  completeRegistration: {
    hint: 'You will then join the organization "{{organizationName}}".'
  },
  handle: {
    title: 'Join Organization',
    description:
      'Do you want to join the organization "{{organization}}" with the following account?',
    userPictureAlt: 'Profile Picture',
    acceptCurrentAccount: 'Join Organization',
    acceptDifferentAccount: 'Join with Different Account'
  }
};
